// The arithmetic of the `carousel` album (phase 074), apart from the DOM so
// it is tested on its own: where a press of the previous or next button
// scrolls the row, and which of the two buttons still has somewhere to go.

export interface TrackMetrics {
  scrollLeft: number
  clientWidth: number
  scrollWidth: number
}

// A press moves the row by most of what it shows, so the last photo of the
// view stays in sight as the first of the next one; scroll snapping then
// settles the row on a photo edge.
export const PAGE_SHARE = 0.8

// The browser reports a fractional scroll position at some zoom levels, so
// an edge is reached within one pixel.
const EDGE_TOLERANCE = 1

export function pageStep(metrics: TrackMetrics): number {
  return Math.max(Math.round(metrics.clientWidth * PAGE_SHARE), 1)
}

export interface Edges {
  scrollable: boolean
  atStart: boolean
  atEnd: boolean
}

export function edgesOf(metrics: TrackMetrics): Edges {
  const room = metrics.scrollWidth - metrics.clientWidth
  return {
    scrollable: room > EDGE_TOLERANCE,
    atStart: metrics.scrollLeft <= EDGE_TOLERANCE,
    atEnd: metrics.scrollLeft >= room - EDGE_TOLERANCE
  }
}
